export const DEFAULT_DESCRIPTION = 'See more of this property'
